/**
 * Generated bundle index. Do not edit.
 */

export * from './i18n-public-api';
